import { render, staticRenderFns } from "./PaymentMethodsTable.vue?vue&type=template&id=2b352c70&"
import script from "./PaymentMethodsTable.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports